/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Bytes: { input: any; output: any; }
  /**
   * 8 bytes signed integer
   *
   */
  Int8: { input: any; output: any; }
};

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelLockupProposal = {
  __typename?: 'CancelLockupProposal';
  administratorApproved: Scalars['Boolean']['output'];
  approvedEvents: Array<ProposalApprovedByRole>;
  createdEvent: ProposalCreated;
  id: Scalars['ID']['output'];
  index: Scalars['BigInt']['output'];
  keyKeeperApproved: Scalars['Boolean']['output'];
  owner: Scalars['Bytes']['output'];
  ownership: Ownership;
  status: Scalars['Int']['output'];
  statusChangedEvents: Array<ProposalStatusChanged>;
  tokenOwnerApproved: Scalars['Boolean']['output'];
};


export type CancelLockupProposalApprovedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalApprovedByRole_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalApprovedByRole_Filter>;
};


export type CancelLockupProposalStatusChangedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalStatusChanged_Filter>;
};

export type CancelLockupProposal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  administratorApproved?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  administratorApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  and?: InputMaybe<Array<InputMaybe<CancelLockupProposal_Filter>>>;
  approvedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_?: InputMaybe<ProposalApprovedByRole_Filter>;
  approvedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent?: InputMaybe<Scalars['String']['input']>;
  createdEvent_?: InputMaybe<ProposalCreated_Filter>;
  createdEvent_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_lt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_lte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  keyKeeperApproved?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  keyKeeperApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  or?: InputMaybe<Array<InputMaybe<CancelLockupProposal_Filter>>>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  ownership_?: InputMaybe<Ownership_Filter>;
  ownership_contains?: InputMaybe<Scalars['String']['input']>;
  ownership_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_ends_with?: InputMaybe<Scalars['String']['input']>;
  ownership_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_gt?: InputMaybe<Scalars['String']['input']>;
  ownership_gte?: InputMaybe<Scalars['String']['input']>;
  ownership_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ownership_lt?: InputMaybe<Scalars['String']['input']>;
  ownership_lte?: InputMaybe<Scalars['String']['input']>;
  ownership_not?: InputMaybe<Scalars['String']['input']>;
  ownership_not_contains?: InputMaybe<Scalars['String']['input']>;
  ownership_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  ownership_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ownership_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  ownership_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_starts_with?: InputMaybe<Scalars['String']['input']>;
  ownership_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  statusChangedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_?: InputMaybe<ProposalStatusChanged_Filter>;
  statusChangedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tokenOwnerApproved?: InputMaybe<Scalars['Boolean']['input']>;
  tokenOwnerApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  tokenOwnerApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  tokenOwnerApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export enum CancelLockupProposal_OrderBy {
  AdministratorApproved = 'administratorApproved',
  ApprovedEvents = 'approvedEvents',
  CreatedEvent = 'createdEvent',
  CreatedEventBlockNumber = 'createdEvent__blockNumber',
  CreatedEventBlockTimestamp = 'createdEvent__blockTimestamp',
  CreatedEventId = 'createdEvent__id',
  CreatedEventParams = 'createdEvent__params',
  CreatedEventProposalIndex = 'createdEvent__proposalIndex',
  CreatedEventProposalType = 'createdEvent__proposalType',
  CreatedEventTransactionHash = 'createdEvent__transactionHash',
  Id = 'id',
  Index = 'index',
  KeyKeeperApproved = 'keyKeeperApproved',
  Owner = 'owner',
  Ownership = 'ownership',
  OwnershipAmount = 'ownership__amount',
  OwnershipId = 'ownership__id',
  OwnershipIndex = 'ownership__index',
  OwnershipLockupDeadline = 'ownership__lockupDeadline',
  OwnershipOwner = 'ownership__owner',
  OwnershipStatus = 'ownership__status',
  Status = 'status',
  StatusChangedEvents = 'statusChangedEvents',
  TokenOwnerApproved = 'tokenOwnerApproved'
}

export type ExtendLockupPeriodProposal = {
  __typename?: 'ExtendLockupPeriodProposal';
  administratorApproved: Scalars['Boolean']['output'];
  approvedEvents: Array<ProposalApprovedByRole>;
  createdEvent: ProposalCreated;
  extensionPeriod: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['BigInt']['output'];
  keyKeeperApproved: Scalars['Boolean']['output'];
  owner: Scalars['Bytes']['output'];
  ownership: Ownership;
  status: Scalars['Int']['output'];
  statusChangedEvents: Array<ProposalStatusChanged>;
};


export type ExtendLockupPeriodProposalApprovedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalApprovedByRole_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalApprovedByRole_Filter>;
};


export type ExtendLockupPeriodProposalStatusChangedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalStatusChanged_Filter>;
};

export type ExtendLockupPeriodProposal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  administratorApproved?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  administratorApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  and?: InputMaybe<Array<InputMaybe<ExtendLockupPeriodProposal_Filter>>>;
  approvedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_?: InputMaybe<ProposalApprovedByRole_Filter>;
  approvedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent?: InputMaybe<Scalars['String']['input']>;
  createdEvent_?: InputMaybe<ProposalCreated_Filter>;
  createdEvent_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_lt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_lte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  extensionPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  extensionPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  extensionPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  extensionPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  extensionPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  extensionPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  extensionPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  extensionPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  keyKeeperApproved?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  keyKeeperApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ExtendLockupPeriodProposal_Filter>>>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  ownership_?: InputMaybe<Ownership_Filter>;
  ownership_contains?: InputMaybe<Scalars['String']['input']>;
  ownership_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_ends_with?: InputMaybe<Scalars['String']['input']>;
  ownership_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_gt?: InputMaybe<Scalars['String']['input']>;
  ownership_gte?: InputMaybe<Scalars['String']['input']>;
  ownership_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ownership_lt?: InputMaybe<Scalars['String']['input']>;
  ownership_lte?: InputMaybe<Scalars['String']['input']>;
  ownership_not?: InputMaybe<Scalars['String']['input']>;
  ownership_not_contains?: InputMaybe<Scalars['String']['input']>;
  ownership_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  ownership_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ownership_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  ownership_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_starts_with?: InputMaybe<Scalars['String']['input']>;
  ownership_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  statusChangedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_?: InputMaybe<ProposalStatusChanged_Filter>;
  statusChangedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum ExtendLockupPeriodProposal_OrderBy {
  AdministratorApproved = 'administratorApproved',
  ApprovedEvents = 'approvedEvents',
  CreatedEvent = 'createdEvent',
  CreatedEventBlockNumber = 'createdEvent__blockNumber',
  CreatedEventBlockTimestamp = 'createdEvent__blockTimestamp',
  CreatedEventId = 'createdEvent__id',
  CreatedEventParams = 'createdEvent__params',
  CreatedEventProposalIndex = 'createdEvent__proposalIndex',
  CreatedEventProposalType = 'createdEvent__proposalType',
  CreatedEventTransactionHash = 'createdEvent__transactionHash',
  ExtensionPeriod = 'extensionPeriod',
  Id = 'id',
  Index = 'index',
  KeyKeeperApproved = 'keyKeeperApproved',
  Owner = 'owner',
  Ownership = 'ownership',
  OwnershipAmount = 'ownership__amount',
  OwnershipId = 'ownership__id',
  OwnershipIndex = 'ownership__index',
  OwnershipLockupDeadline = 'ownership__lockupDeadline',
  OwnershipOwner = 'ownership__owner',
  OwnershipStatus = 'ownership__status',
  Status = 'status',
  StatusChangedEvents = 'statusChangedEvents'
}

export type GrantKeyKeeperProposal = {
  __typename?: 'GrantKeyKeeperProposal';
  administratorApproved: Scalars['Boolean']['output'];
  approvedEvents: Array<ProposalApprovedByRole>;
  createdEvent: ProposalCreated;
  id: Scalars['ID']['output'];
  keyKeeperApproved: Scalars['Boolean']['output'];
  newKeyKeeper: Scalars['Bytes']['output'];
  status: Scalars['Int']['output'];
  statusChangedEvents: Array<ProposalStatusChanged>;
};


export type GrantKeyKeeperProposalApprovedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalApprovedByRole_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalApprovedByRole_Filter>;
};


export type GrantKeyKeeperProposalStatusChangedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalStatusChanged_Filter>;
};

export type GrantKeyKeeperProposal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  administratorApproved?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  administratorApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  and?: InputMaybe<Array<InputMaybe<GrantKeyKeeperProposal_Filter>>>;
  approvedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_?: InputMaybe<ProposalApprovedByRole_Filter>;
  approvedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent?: InputMaybe<Scalars['String']['input']>;
  createdEvent_?: InputMaybe<ProposalCreated_Filter>;
  createdEvent_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_lt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_lte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyKeeperApproved?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  keyKeeperApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  newKeyKeeper?: InputMaybe<Scalars['Bytes']['input']>;
  newKeyKeeper_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newKeyKeeper_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newKeyKeeper_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newKeyKeeper_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newKeyKeeper_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newKeyKeeper_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newKeyKeeper_not?: InputMaybe<Scalars['Bytes']['input']>;
  newKeyKeeper_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newKeyKeeper_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<GrantKeyKeeperProposal_Filter>>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  statusChangedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_?: InputMaybe<ProposalStatusChanged_Filter>;
  statusChangedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum GrantKeyKeeperProposal_OrderBy {
  AdministratorApproved = 'administratorApproved',
  ApprovedEvents = 'approvedEvents',
  CreatedEvent = 'createdEvent',
  CreatedEventBlockNumber = 'createdEvent__blockNumber',
  CreatedEventBlockTimestamp = 'createdEvent__blockTimestamp',
  CreatedEventId = 'createdEvent__id',
  CreatedEventParams = 'createdEvent__params',
  CreatedEventProposalIndex = 'createdEvent__proposalIndex',
  CreatedEventProposalType = 'createdEvent__proposalType',
  CreatedEventTransactionHash = 'createdEvent__transactionHash',
  Id = 'id',
  KeyKeeperApproved = 'keyKeeperApproved',
  NewKeyKeeper = 'newKeyKeeper',
  Status = 'status',
  StatusChangedEvents = 'statusChangedEvents'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Ownership = {
  __typename?: 'Ownership';
  amount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['BigInt']['output'];
  lockupDeadline: Scalars['BigInt']['output'];
  owner: Scalars['Bytes']['output'];
  setEvent: OwnershipSet;
  status: Scalars['Int']['output'];
  updateEvents: Array<OwnershipUpdated>;
};


export type OwnershipUpdateEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OwnershipUpdated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OwnershipUpdated_Filter>;
};

export type OwnershipSet = {
  __typename?: 'OwnershipSet';
  amount: Scalars['BigInt']['output'];
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  index: Scalars['BigInt']['output'];
  lockupDeadline: Scalars['BigInt']['output'];
  newOwner: Scalars['Bytes']['output'];
  status: Scalars['Int']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type OwnershipSet_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<OwnershipSet_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockupDeadline?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockupDeadline_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_not?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newOwner?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newOwner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<OwnershipSet_Filter>>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum OwnershipSet_OrderBy {
  Amount = 'amount',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Index = 'index',
  LockupDeadline = 'lockupDeadline',
  NewOwner = 'newOwner',
  Status = 'status',
  TransactionHash = 'transactionHash'
}

export type OwnershipUpdated = {
  __typename?: 'OwnershipUpdated';
  amount: Scalars['BigInt']['output'];
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  index: Scalars['BigInt']['output'];
  lockupDeadline: Scalars['BigInt']['output'];
  newOwner: Scalars['Bytes']['output'];
  status: Scalars['Int']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type OwnershipUpdated_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<OwnershipUpdated_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockupDeadline?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockupDeadline_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_not?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newOwner?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newOwner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<OwnershipUpdated_Filter>>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum OwnershipUpdated_OrderBy {
  Amount = 'amount',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Index = 'index',
  LockupDeadline = 'lockupDeadline',
  NewOwner = 'newOwner',
  Status = 'status',
  TransactionHash = 'transactionHash'
}

export type Ownership_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Ownership_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockupDeadline?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockupDeadline_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_not?: InputMaybe<Scalars['BigInt']['input']>;
  lockupDeadline_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Ownership_Filter>>>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  setEvent?: InputMaybe<Scalars['String']['input']>;
  setEvent_?: InputMaybe<OwnershipSet_Filter>;
  setEvent_contains?: InputMaybe<Scalars['String']['input']>;
  setEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  setEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEvent_gt?: InputMaybe<Scalars['String']['input']>;
  setEvent_gte?: InputMaybe<Scalars['String']['input']>;
  setEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setEvent_lt?: InputMaybe<Scalars['String']['input']>;
  setEvent_lte?: InputMaybe<Scalars['String']['input']>;
  setEvent_not?: InputMaybe<Scalars['String']['input']>;
  setEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  setEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  setEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  updateEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  updateEvents_?: InputMaybe<OwnershipUpdated_Filter>;
  updateEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  updateEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  updateEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  updateEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  updateEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum Ownership_OrderBy {
  Amount = 'amount',
  Id = 'id',
  Index = 'index',
  LockupDeadline = 'lockupDeadline',
  Owner = 'owner',
  SetEvent = 'setEvent',
  SetEventAmount = 'setEvent__amount',
  SetEventBlockNumber = 'setEvent__blockNumber',
  SetEventBlockTimestamp = 'setEvent__blockTimestamp',
  SetEventId = 'setEvent__id',
  SetEventIndex = 'setEvent__index',
  SetEventLockupDeadline = 'setEvent__lockupDeadline',
  SetEventNewOwner = 'setEvent__newOwner',
  SetEventStatus = 'setEvent__status',
  SetEventTransactionHash = 'setEvent__transactionHash',
  Status = 'status',
  UpdateEvents = 'updateEvents'
}

export type ProposalApprovedByRole = {
  __typename?: 'ProposalApprovedByRole';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  proposalIndex: Scalars['BigInt']['output'];
  proposalType: Scalars['Int']['output'];
  role: Scalars['Bytes']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type ProposalApprovedByRole_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ProposalApprovedByRole_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ProposalApprovedByRole_Filter>>>;
  proposalIndex?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_gt?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_gte?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  proposalIndex_lt?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_lte?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_not?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  proposalType?: InputMaybe<Scalars['Int']['input']>;
  proposalType_gt?: InputMaybe<Scalars['Int']['input']>;
  proposalType_gte?: InputMaybe<Scalars['Int']['input']>;
  proposalType_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  proposalType_lt?: InputMaybe<Scalars['Int']['input']>;
  proposalType_lte?: InputMaybe<Scalars['Int']['input']>;
  proposalType_not?: InputMaybe<Scalars['Int']['input']>;
  proposalType_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  role?: InputMaybe<Scalars['Bytes']['input']>;
  role_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_gt?: InputMaybe<Scalars['Bytes']['input']>;
  role_gte?: InputMaybe<Scalars['Bytes']['input']>;
  role_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  role_lt?: InputMaybe<Scalars['Bytes']['input']>;
  role_lte?: InputMaybe<Scalars['Bytes']['input']>;
  role_not?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum ProposalApprovedByRole_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  ProposalIndex = 'proposalIndex',
  ProposalType = 'proposalType',
  Role = 'role',
  TransactionHash = 'transactionHash'
}

export type ProposalCreated = {
  __typename?: 'ProposalCreated';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  params: Scalars['Bytes']['output'];
  proposalIndex: Scalars['BigInt']['output'];
  proposalType: Scalars['Int']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type ProposalCreated_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ProposalCreated_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ProposalCreated_Filter>>>;
  params?: InputMaybe<Scalars['Bytes']['input']>;
  params_contains?: InputMaybe<Scalars['Bytes']['input']>;
  params_gt?: InputMaybe<Scalars['Bytes']['input']>;
  params_gte?: InputMaybe<Scalars['Bytes']['input']>;
  params_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  params_lt?: InputMaybe<Scalars['Bytes']['input']>;
  params_lte?: InputMaybe<Scalars['Bytes']['input']>;
  params_not?: InputMaybe<Scalars['Bytes']['input']>;
  params_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  params_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  proposalIndex?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_gt?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_gte?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  proposalIndex_lt?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_lte?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_not?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  proposalType?: InputMaybe<Scalars['Int']['input']>;
  proposalType_gt?: InputMaybe<Scalars['Int']['input']>;
  proposalType_gte?: InputMaybe<Scalars['Int']['input']>;
  proposalType_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  proposalType_lt?: InputMaybe<Scalars['Int']['input']>;
  proposalType_lte?: InputMaybe<Scalars['Int']['input']>;
  proposalType_not?: InputMaybe<Scalars['Int']['input']>;
  proposalType_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum ProposalCreated_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Params = 'params',
  ProposalIndex = 'proposalIndex',
  ProposalType = 'proposalType',
  TransactionHash = 'transactionHash'
}

export type ProposalStatusChanged = {
  __typename?: 'ProposalStatusChanged';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  newStatus: Scalars['Int']['output'];
  proposalIndex: Scalars['BigInt']['output'];
  proposalType: Scalars['Int']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type ProposalStatusChanged_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ProposalStatusChanged_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newStatus?: InputMaybe<Scalars['Int']['input']>;
  newStatus_gt?: InputMaybe<Scalars['Int']['input']>;
  newStatus_gte?: InputMaybe<Scalars['Int']['input']>;
  newStatus_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  newStatus_lt?: InputMaybe<Scalars['Int']['input']>;
  newStatus_lte?: InputMaybe<Scalars['Int']['input']>;
  newStatus_not?: InputMaybe<Scalars['Int']['input']>;
  newStatus_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ProposalStatusChanged_Filter>>>;
  proposalIndex?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_gt?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_gte?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  proposalIndex_lt?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_lte?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_not?: InputMaybe<Scalars['BigInt']['input']>;
  proposalIndex_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  proposalType?: InputMaybe<Scalars['Int']['input']>;
  proposalType_gt?: InputMaybe<Scalars['Int']['input']>;
  proposalType_gte?: InputMaybe<Scalars['Int']['input']>;
  proposalType_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  proposalType_lt?: InputMaybe<Scalars['Int']['input']>;
  proposalType_lte?: InputMaybe<Scalars['Int']['input']>;
  proposalType_not?: InputMaybe<Scalars['Int']['input']>;
  proposalType_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum ProposalStatusChanged_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  NewStatus = 'newStatus',
  ProposalIndex = 'proposalIndex',
  ProposalType = 'proposalType',
  TransactionHash = 'transactionHash'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  cancelLockupProposal?: Maybe<CancelLockupProposal>;
  cancelLockupProposals: Array<CancelLockupProposal>;
  extendLockupPeriodProposal?: Maybe<ExtendLockupPeriodProposal>;
  extendLockupPeriodProposals: Array<ExtendLockupPeriodProposal>;
  grantKeyKeeperProposal?: Maybe<GrantKeyKeeperProposal>;
  grantKeyKeeperProposals: Array<GrantKeyKeeperProposal>;
  ownership?: Maybe<Ownership>;
  ownershipSet?: Maybe<OwnershipSet>;
  ownershipSets: Array<OwnershipSet>;
  ownershipUpdated?: Maybe<OwnershipUpdated>;
  ownershipUpdateds: Array<OwnershipUpdated>;
  ownerships: Array<Ownership>;
  proposalApprovedByRole?: Maybe<ProposalApprovedByRole>;
  proposalApprovedByRoles: Array<ProposalApprovedByRole>;
  proposalCreated?: Maybe<ProposalCreated>;
  proposalCreateds: Array<ProposalCreated>;
  proposalStatusChanged?: Maybe<ProposalStatusChanged>;
  proposalStatusChangeds: Array<ProposalStatusChanged>;
  revokeKeyKeeperProposal?: Maybe<RevokeKeyKeeperProposal>;
  revokeKeyKeeperProposals: Array<RevokeKeyKeeperProposal>;
  role?: Maybe<Role>;
  roleGranted?: Maybe<RoleGranted>;
  roleGranteds: Array<RoleGranted>;
  roleRevoked?: Maybe<RoleRevoked>;
  roleRevokeds: Array<RoleRevoked>;
  roles: Array<Role>;
  transferOwnershipProposal?: Maybe<TransferOwnershipProposal>;
  transferOwnershipProposals: Array<TransferOwnershipProposal>;
  transferTokenOwnershipProposal?: Maybe<TransferTokenOwnershipProposal>;
  transferTokenOwnershipProposals: Array<TransferTokenOwnershipProposal>;
  upgradeableProposal?: Maybe<UpgradeableProposal>;
  upgradeableProposalApproved?: Maybe<UpgradeableProposalApproved>;
  upgradeableProposalApproveds: Array<UpgradeableProposalApproved>;
  upgradeableProposalCreated?: Maybe<UpgradeableProposalCreated>;
  upgradeableProposalCreateds: Array<UpgradeableProposalCreated>;
  upgradeableProposalStatusChanged?: Maybe<UpgradeableProposalStatusChanged>;
  upgradeableProposalStatusChangeds: Array<UpgradeableProposalStatusChanged>;
  upgradeableProposals: Array<UpgradeableProposal>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryCancelLockupProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryCancelLockupProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CancelLockupProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<CancelLockupProposal_Filter>;
};


export type QueryExtendLockupPeriodProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryExtendLockupPeriodProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExtendLockupPeriodProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ExtendLockupPeriodProposal_Filter>;
};


export type QueryGrantKeyKeeperProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryGrantKeyKeeperProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GrantKeyKeeperProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<GrantKeyKeeperProposal_Filter>;
};


export type QueryOwnershipArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOwnershipSetArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOwnershipSetsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OwnershipSet_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OwnershipSet_Filter>;
};


export type QueryOwnershipUpdatedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOwnershipUpdatedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OwnershipUpdated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OwnershipUpdated_Filter>;
};


export type QueryOwnershipsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Ownership_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Ownership_Filter>;
};


export type QueryProposalApprovedByRoleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryProposalApprovedByRolesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalApprovedByRole_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProposalApprovedByRole_Filter>;
};


export type QueryProposalCreatedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryProposalCreatedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalCreated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProposalCreated_Filter>;
};


export type QueryProposalStatusChangedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryProposalStatusChangedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProposalStatusChanged_Filter>;
};


export type QueryRevokeKeyKeeperProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRevokeKeyKeeperProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RevokeKeyKeeperProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RevokeKeyKeeperProposal_Filter>;
};


export type QueryRoleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRoleGrantedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRoleGrantedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RoleGranted_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RoleGranted_Filter>;
};


export type QueryRoleRevokedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRoleRevokedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RoleRevoked_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RoleRevoked_Filter>;
};


export type QueryRolesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Role_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Role_Filter>;
};


export type QueryTransferOwnershipProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTransferOwnershipProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransferOwnershipProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TransferOwnershipProposal_Filter>;
};


export type QueryTransferTokenOwnershipProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTransferTokenOwnershipProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransferTokenOwnershipProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TransferTokenOwnershipProposal_Filter>;
};


export type QueryUpgradeableProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUpgradeableProposalApprovedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUpgradeableProposalApprovedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposalApproved_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<UpgradeableProposalApproved_Filter>;
};


export type QueryUpgradeableProposalCreatedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUpgradeableProposalCreatedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposalCreated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<UpgradeableProposalCreated_Filter>;
};


export type QueryUpgradeableProposalStatusChangedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUpgradeableProposalStatusChangedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<UpgradeableProposalStatusChanged_Filter>;
};


export type QueryUpgradeableProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<UpgradeableProposal_Filter>;
};

export type RevokeKeyKeeperProposal = {
  __typename?: 'RevokeKeyKeeperProposal';
  administratorApproved: Scalars['Boolean']['output'];
  approvedEvents: Array<ProposalApprovedByRole>;
  createdEvent: ProposalCreated;
  id: Scalars['ID']['output'];
  keyKeeper: Scalars['Bytes']['output'];
  keyKeeperApproved: Scalars['Boolean']['output'];
  status: Scalars['Int']['output'];
  statusChangedEvents: Array<ProposalStatusChanged>;
};


export type RevokeKeyKeeperProposalApprovedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalApprovedByRole_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalApprovedByRole_Filter>;
};


export type RevokeKeyKeeperProposalStatusChangedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalStatusChanged_Filter>;
};

export type RevokeKeyKeeperProposal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  administratorApproved?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  administratorApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  and?: InputMaybe<Array<InputMaybe<RevokeKeyKeeperProposal_Filter>>>;
  approvedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_?: InputMaybe<ProposalApprovedByRole_Filter>;
  approvedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent?: InputMaybe<Scalars['String']['input']>;
  createdEvent_?: InputMaybe<ProposalCreated_Filter>;
  createdEvent_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_lt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_lte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyKeeper?: InputMaybe<Scalars['Bytes']['input']>;
  keyKeeperApproved?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  keyKeeperApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  keyKeeper_contains?: InputMaybe<Scalars['Bytes']['input']>;
  keyKeeper_gt?: InputMaybe<Scalars['Bytes']['input']>;
  keyKeeper_gte?: InputMaybe<Scalars['Bytes']['input']>;
  keyKeeper_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  keyKeeper_lt?: InputMaybe<Scalars['Bytes']['input']>;
  keyKeeper_lte?: InputMaybe<Scalars['Bytes']['input']>;
  keyKeeper_not?: InputMaybe<Scalars['Bytes']['input']>;
  keyKeeper_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  keyKeeper_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<RevokeKeyKeeperProposal_Filter>>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  statusChangedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_?: InputMaybe<ProposalStatusChanged_Filter>;
  statusChangedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum RevokeKeyKeeperProposal_OrderBy {
  AdministratorApproved = 'administratorApproved',
  ApprovedEvents = 'approvedEvents',
  CreatedEvent = 'createdEvent',
  CreatedEventBlockNumber = 'createdEvent__blockNumber',
  CreatedEventBlockTimestamp = 'createdEvent__blockTimestamp',
  CreatedEventId = 'createdEvent__id',
  CreatedEventParams = 'createdEvent__params',
  CreatedEventProposalIndex = 'createdEvent__proposalIndex',
  CreatedEventProposalType = 'createdEvent__proposalType',
  CreatedEventTransactionHash = 'createdEvent__transactionHash',
  Id = 'id',
  KeyKeeper = 'keyKeeper',
  KeyKeeperApproved = 'keyKeeperApproved',
  Status = 'status',
  StatusChangedEvents = 'statusChangedEvents'
}

export type Role = {
  __typename?: 'Role';
  account: Scalars['Bytes']['output'];
  grantEvent: RoleGranted;
  id: Scalars['ID']['output'];
  role: Scalars['Bytes']['output'];
};

export type RoleGranted = {
  __typename?: 'RoleGranted';
  account: Scalars['Bytes']['output'];
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  role: Scalars['Bytes']['output'];
  sender: Scalars['Bytes']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type RoleGranted_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['Bytes']['input']>;
  account_contains?: InputMaybe<Scalars['Bytes']['input']>;
  account_gt?: InputMaybe<Scalars['Bytes']['input']>;
  account_gte?: InputMaybe<Scalars['Bytes']['input']>;
  account_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  account_lt?: InputMaybe<Scalars['Bytes']['input']>;
  account_lte?: InputMaybe<Scalars['Bytes']['input']>;
  account_not?: InputMaybe<Scalars['Bytes']['input']>;
  account_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<RoleGranted_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<RoleGranted_Filter>>>;
  role?: InputMaybe<Scalars['Bytes']['input']>;
  role_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_gt?: InputMaybe<Scalars['Bytes']['input']>;
  role_gte?: InputMaybe<Scalars['Bytes']['input']>;
  role_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  role_lt?: InputMaybe<Scalars['Bytes']['input']>;
  role_lte?: InputMaybe<Scalars['Bytes']['input']>;
  role_not?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sender?: InputMaybe<Scalars['Bytes']['input']>;
  sender_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sender_gt?: InputMaybe<Scalars['Bytes']['input']>;
  sender_gte?: InputMaybe<Scalars['Bytes']['input']>;
  sender_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sender_lt?: InputMaybe<Scalars['Bytes']['input']>;
  sender_lte?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum RoleGranted_OrderBy {
  Account = 'account',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Role = 'role',
  Sender = 'sender',
  TransactionHash = 'transactionHash'
}

export type RoleRevoked = {
  __typename?: 'RoleRevoked';
  account: Scalars['Bytes']['output'];
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  role: Scalars['Bytes']['output'];
  sender: Scalars['Bytes']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type RoleRevoked_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['Bytes']['input']>;
  account_contains?: InputMaybe<Scalars['Bytes']['input']>;
  account_gt?: InputMaybe<Scalars['Bytes']['input']>;
  account_gte?: InputMaybe<Scalars['Bytes']['input']>;
  account_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  account_lt?: InputMaybe<Scalars['Bytes']['input']>;
  account_lte?: InputMaybe<Scalars['Bytes']['input']>;
  account_not?: InputMaybe<Scalars['Bytes']['input']>;
  account_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<RoleRevoked_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<RoleRevoked_Filter>>>;
  role?: InputMaybe<Scalars['Bytes']['input']>;
  role_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_gt?: InputMaybe<Scalars['Bytes']['input']>;
  role_gte?: InputMaybe<Scalars['Bytes']['input']>;
  role_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  role_lt?: InputMaybe<Scalars['Bytes']['input']>;
  role_lte?: InputMaybe<Scalars['Bytes']['input']>;
  role_not?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sender?: InputMaybe<Scalars['Bytes']['input']>;
  sender_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sender_gt?: InputMaybe<Scalars['Bytes']['input']>;
  sender_gte?: InputMaybe<Scalars['Bytes']['input']>;
  sender_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sender_lt?: InputMaybe<Scalars['Bytes']['input']>;
  sender_lte?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum RoleRevoked_OrderBy {
  Account = 'account',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Role = 'role',
  Sender = 'sender',
  TransactionHash = 'transactionHash'
}

export type Role_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['Bytes']['input']>;
  account_contains?: InputMaybe<Scalars['Bytes']['input']>;
  account_gt?: InputMaybe<Scalars['Bytes']['input']>;
  account_gte?: InputMaybe<Scalars['Bytes']['input']>;
  account_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  account_lt?: InputMaybe<Scalars['Bytes']['input']>;
  account_lte?: InputMaybe<Scalars['Bytes']['input']>;
  account_not?: InputMaybe<Scalars['Bytes']['input']>;
  account_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Role_Filter>>>;
  grantEvent?: InputMaybe<Scalars['String']['input']>;
  grantEvent_?: InputMaybe<RoleGranted_Filter>;
  grantEvent_contains?: InputMaybe<Scalars['String']['input']>;
  grantEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  grantEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  grantEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  grantEvent_gt?: InputMaybe<Scalars['String']['input']>;
  grantEvent_gte?: InputMaybe<Scalars['String']['input']>;
  grantEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  grantEvent_lt?: InputMaybe<Scalars['String']['input']>;
  grantEvent_lte?: InputMaybe<Scalars['String']['input']>;
  grantEvent_not?: InputMaybe<Scalars['String']['input']>;
  grantEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  grantEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  grantEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  grantEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  grantEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  grantEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  grantEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  grantEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  grantEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Role_Filter>>>;
  role?: InputMaybe<Scalars['Bytes']['input']>;
  role_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_gt?: InputMaybe<Scalars['Bytes']['input']>;
  role_gte?: InputMaybe<Scalars['Bytes']['input']>;
  role_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  role_lt?: InputMaybe<Scalars['Bytes']['input']>;
  role_lte?: InputMaybe<Scalars['Bytes']['input']>;
  role_not?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum Role_OrderBy {
  Account = 'account',
  GrantEvent = 'grantEvent',
  GrantEventAccount = 'grantEvent__account',
  GrantEventBlockNumber = 'grantEvent__blockNumber',
  GrantEventBlockTimestamp = 'grantEvent__blockTimestamp',
  GrantEventId = 'grantEvent__id',
  GrantEventRole = 'grantEvent__role',
  GrantEventSender = 'grantEvent__sender',
  GrantEventTransactionHash = 'grantEvent__transactionHash',
  Id = 'id',
  Role = 'role'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  cancelLockupProposal?: Maybe<CancelLockupProposal>;
  cancelLockupProposals: Array<CancelLockupProposal>;
  extendLockupPeriodProposal?: Maybe<ExtendLockupPeriodProposal>;
  extendLockupPeriodProposals: Array<ExtendLockupPeriodProposal>;
  grantKeyKeeperProposal?: Maybe<GrantKeyKeeperProposal>;
  grantKeyKeeperProposals: Array<GrantKeyKeeperProposal>;
  ownership?: Maybe<Ownership>;
  ownershipSet?: Maybe<OwnershipSet>;
  ownershipSets: Array<OwnershipSet>;
  ownershipUpdated?: Maybe<OwnershipUpdated>;
  ownershipUpdateds: Array<OwnershipUpdated>;
  ownerships: Array<Ownership>;
  proposalApprovedByRole?: Maybe<ProposalApprovedByRole>;
  proposalApprovedByRoles: Array<ProposalApprovedByRole>;
  proposalCreated?: Maybe<ProposalCreated>;
  proposalCreateds: Array<ProposalCreated>;
  proposalStatusChanged?: Maybe<ProposalStatusChanged>;
  proposalStatusChangeds: Array<ProposalStatusChanged>;
  revokeKeyKeeperProposal?: Maybe<RevokeKeyKeeperProposal>;
  revokeKeyKeeperProposals: Array<RevokeKeyKeeperProposal>;
  role?: Maybe<Role>;
  roleGranted?: Maybe<RoleGranted>;
  roleGranteds: Array<RoleGranted>;
  roleRevoked?: Maybe<RoleRevoked>;
  roleRevokeds: Array<RoleRevoked>;
  roles: Array<Role>;
  transferOwnershipProposal?: Maybe<TransferOwnershipProposal>;
  transferOwnershipProposals: Array<TransferOwnershipProposal>;
  transferTokenOwnershipProposal?: Maybe<TransferTokenOwnershipProposal>;
  transferTokenOwnershipProposals: Array<TransferTokenOwnershipProposal>;
  upgradeableProposal?: Maybe<UpgradeableProposal>;
  upgradeableProposalApproved?: Maybe<UpgradeableProposalApproved>;
  upgradeableProposalApproveds: Array<UpgradeableProposalApproved>;
  upgradeableProposalCreated?: Maybe<UpgradeableProposalCreated>;
  upgradeableProposalCreateds: Array<UpgradeableProposalCreated>;
  upgradeableProposalStatusChanged?: Maybe<UpgradeableProposalStatusChanged>;
  upgradeableProposalStatusChangeds: Array<UpgradeableProposalStatusChanged>;
  upgradeableProposals: Array<UpgradeableProposal>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionCancelLockupProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionCancelLockupProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CancelLockupProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<CancelLockupProposal_Filter>;
};


export type SubscriptionExtendLockupPeriodProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionExtendLockupPeriodProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExtendLockupPeriodProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ExtendLockupPeriodProposal_Filter>;
};


export type SubscriptionGrantKeyKeeperProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionGrantKeyKeeperProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GrantKeyKeeperProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<GrantKeyKeeperProposal_Filter>;
};


export type SubscriptionOwnershipArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOwnershipSetArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOwnershipSetsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OwnershipSet_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OwnershipSet_Filter>;
};


export type SubscriptionOwnershipUpdatedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOwnershipUpdatedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OwnershipUpdated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OwnershipUpdated_Filter>;
};


export type SubscriptionOwnershipsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Ownership_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Ownership_Filter>;
};


export type SubscriptionProposalApprovedByRoleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionProposalApprovedByRolesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalApprovedByRole_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProposalApprovedByRole_Filter>;
};


export type SubscriptionProposalCreatedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionProposalCreatedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalCreated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProposalCreated_Filter>;
};


export type SubscriptionProposalStatusChangedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionProposalStatusChangedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ProposalStatusChanged_Filter>;
};


export type SubscriptionRevokeKeyKeeperProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRevokeKeyKeeperProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RevokeKeyKeeperProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RevokeKeyKeeperProposal_Filter>;
};


export type SubscriptionRoleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRoleGrantedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRoleGrantedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RoleGranted_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RoleGranted_Filter>;
};


export type SubscriptionRoleRevokedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRoleRevokedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RoleRevoked_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RoleRevoked_Filter>;
};


export type SubscriptionRolesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Role_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Role_Filter>;
};


export type SubscriptionTransferOwnershipProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTransferOwnershipProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransferOwnershipProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TransferOwnershipProposal_Filter>;
};


export type SubscriptionTransferTokenOwnershipProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTransferTokenOwnershipProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransferTokenOwnershipProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TransferTokenOwnershipProposal_Filter>;
};


export type SubscriptionUpgradeableProposalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionUpgradeableProposalApprovedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionUpgradeableProposalApprovedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposalApproved_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<UpgradeableProposalApproved_Filter>;
};


export type SubscriptionUpgradeableProposalCreatedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionUpgradeableProposalCreatedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposalCreated_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<UpgradeableProposalCreated_Filter>;
};


export type SubscriptionUpgradeableProposalStatusChangedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionUpgradeableProposalStatusChangedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<UpgradeableProposalStatusChanged_Filter>;
};


export type SubscriptionUpgradeableProposalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<UpgradeableProposal_Filter>;
};

export type TransferOwnershipProposal = {
  __typename?: 'TransferOwnershipProposal';
  administratorApproved: Scalars['Boolean']['output'];
  approvedEvents: Array<ProposalApprovedByRole>;
  createdEvent: ProposalCreated;
  id: Scalars['ID']['output'];
  keyKeeperApproved: Scalars['Boolean']['output'];
  newOwner: Scalars['Bytes']['output'];
  status: Scalars['Int']['output'];
  statusChangedEvents: Array<ProposalStatusChanged>;
};


export type TransferOwnershipProposalApprovedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalApprovedByRole_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalApprovedByRole_Filter>;
};


export type TransferOwnershipProposalStatusChangedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalStatusChanged_Filter>;
};

export type TransferOwnershipProposal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  administratorApproved?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  administratorApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  administratorApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  and?: InputMaybe<Array<InputMaybe<TransferOwnershipProposal_Filter>>>;
  approvedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_?: InputMaybe<ProposalApprovedByRole_Filter>;
  approvedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent?: InputMaybe<Scalars['String']['input']>;
  createdEvent_?: InputMaybe<ProposalCreated_Filter>;
  createdEvent_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_lt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_lte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyKeeperApproved?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  keyKeeperApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  newOwner?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newOwner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<TransferOwnershipProposal_Filter>>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  statusChangedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_?: InputMaybe<ProposalStatusChanged_Filter>;
  statusChangedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum TransferOwnershipProposal_OrderBy {
  AdministratorApproved = 'administratorApproved',
  ApprovedEvents = 'approvedEvents',
  CreatedEvent = 'createdEvent',
  CreatedEventBlockNumber = 'createdEvent__blockNumber',
  CreatedEventBlockTimestamp = 'createdEvent__blockTimestamp',
  CreatedEventId = 'createdEvent__id',
  CreatedEventParams = 'createdEvent__params',
  CreatedEventProposalIndex = 'createdEvent__proposalIndex',
  CreatedEventProposalType = 'createdEvent__proposalType',
  CreatedEventTransactionHash = 'createdEvent__transactionHash',
  Id = 'id',
  KeyKeeperApproved = 'keyKeeperApproved',
  NewOwner = 'newOwner',
  Status = 'status',
  StatusChangedEvents = 'statusChangedEvents'
}

export type TransferTokenOwnershipProposal = {
  __typename?: 'TransferTokenOwnershipProposal';
  approvedEvents: Array<ProposalApprovedByRole>;
  createdEvent: ProposalCreated;
  id: Scalars['ID']['output'];
  index: Scalars['BigInt']['output'];
  newOwner: Scalars['Bytes']['output'];
  owner: Scalars['Bytes']['output'];
  ownership: Ownership;
  status: Scalars['Int']['output'];
  statusChangedEvents: Array<ProposalStatusChanged>;
};


export type TransferTokenOwnershipProposalApprovedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalApprovedByRole_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalApprovedByRole_Filter>;
};


export type TransferTokenOwnershipProposalStatusChangedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalStatusChanged_Filter>;
};

export type TransferTokenOwnershipProposal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<TransferTokenOwnershipProposal_Filter>>>;
  approvedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_?: InputMaybe<ProposalApprovedByRole_Filter>;
  approvedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent?: InputMaybe<Scalars['String']['input']>;
  createdEvent_?: InputMaybe<ProposalCreated_Filter>;
  createdEvent_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_lt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_lte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  index_gt?: InputMaybe<Scalars['BigInt']['input']>;
  index_gte?: InputMaybe<Scalars['BigInt']['input']>;
  index_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  index_lt?: InputMaybe<Scalars['BigInt']['input']>;
  index_lte?: InputMaybe<Scalars['BigInt']['input']>;
  index_not?: InputMaybe<Scalars['BigInt']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newOwner?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newOwner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOwner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<TransferTokenOwnershipProposal_Filter>>>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_gte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_lt?: InputMaybe<Scalars['Bytes']['input']>;
  owner_lte?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  ownership?: InputMaybe<Scalars['String']['input']>;
  ownership_?: InputMaybe<Ownership_Filter>;
  ownership_contains?: InputMaybe<Scalars['String']['input']>;
  ownership_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_ends_with?: InputMaybe<Scalars['String']['input']>;
  ownership_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_gt?: InputMaybe<Scalars['String']['input']>;
  ownership_gte?: InputMaybe<Scalars['String']['input']>;
  ownership_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ownership_lt?: InputMaybe<Scalars['String']['input']>;
  ownership_lte?: InputMaybe<Scalars['String']['input']>;
  ownership_not?: InputMaybe<Scalars['String']['input']>;
  ownership_not_contains?: InputMaybe<Scalars['String']['input']>;
  ownership_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  ownership_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  ownership_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  ownership_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  ownership_starts_with?: InputMaybe<Scalars['String']['input']>;
  ownership_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  statusChangedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_?: InputMaybe<ProposalStatusChanged_Filter>;
  statusChangedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum TransferTokenOwnershipProposal_OrderBy {
  ApprovedEvents = 'approvedEvents',
  CreatedEvent = 'createdEvent',
  CreatedEventBlockNumber = 'createdEvent__blockNumber',
  CreatedEventBlockTimestamp = 'createdEvent__blockTimestamp',
  CreatedEventId = 'createdEvent__id',
  CreatedEventParams = 'createdEvent__params',
  CreatedEventProposalIndex = 'createdEvent__proposalIndex',
  CreatedEventProposalType = 'createdEvent__proposalType',
  CreatedEventTransactionHash = 'createdEvent__transactionHash',
  Id = 'id',
  Index = 'index',
  NewOwner = 'newOwner',
  Owner = 'owner',
  Ownership = 'ownership',
  OwnershipAmount = 'ownership__amount',
  OwnershipId = 'ownership__id',
  OwnershipIndex = 'ownership__index',
  OwnershipLockupDeadline = 'ownership__lockupDeadline',
  OwnershipOwner = 'ownership__owner',
  OwnershipStatus = 'ownership__status',
  Status = 'status',
  StatusChangedEvents = 'statusChangedEvents'
}

export type UpgradeableProposal = {
  __typename?: 'UpgradeableProposal';
  approvedEvents: Array<UpgradeableProposalApproved>;
  createdEvent: UpgradeableProposalCreated;
  id: Scalars['ID']['output'];
  keyKeeperApproved: Scalars['Boolean']['output'];
  newImplementation: Scalars['Bytes']['output'];
  ownerApproved: Scalars['Boolean']['output'];
  status: Scalars['Int']['output'];
  statusChangedEvents: Array<UpgradeableProposalStatusChanged>;
};


export type UpgradeableProposalApprovedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposalApproved_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UpgradeableProposalApproved_Filter>;
};


export type UpgradeableProposalStatusChangedEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposalStatusChanged_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UpgradeableProposalStatusChanged_Filter>;
};

export type UpgradeableProposalApproved = {
  __typename?: 'UpgradeableProposalApproved';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  newImplementation: Scalars['Bytes']['output'];
  role: Scalars['Bytes']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type UpgradeableProposalApproved_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<UpgradeableProposalApproved_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newImplementation?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newImplementation_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<UpgradeableProposalApproved_Filter>>>;
  role?: InputMaybe<Scalars['Bytes']['input']>;
  role_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_gt?: InputMaybe<Scalars['Bytes']['input']>;
  role_gte?: InputMaybe<Scalars['Bytes']['input']>;
  role_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  role_lt?: InputMaybe<Scalars['Bytes']['input']>;
  role_lte?: InputMaybe<Scalars['Bytes']['input']>;
  role_not?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  role_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum UpgradeableProposalApproved_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  NewImplementation = 'newImplementation',
  Role = 'role',
  TransactionHash = 'transactionHash'
}

export type UpgradeableProposalCreated = {
  __typename?: 'UpgradeableProposalCreated';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  newImplementation: Scalars['Bytes']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type UpgradeableProposalCreated_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<UpgradeableProposalCreated_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newImplementation?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newImplementation_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<UpgradeableProposalCreated_Filter>>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum UpgradeableProposalCreated_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  NewImplementation = 'newImplementation',
  TransactionHash = 'transactionHash'
}

export type UpgradeableProposalStatusChanged = {
  __typename?: 'UpgradeableProposalStatusChanged';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['Bytes']['output'];
  newImplementation: Scalars['Bytes']['output'];
  newStatus: Scalars['Int']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type UpgradeableProposalStatusChanged_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<UpgradeableProposalStatusChanged_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Bytes']['input']>;
  id_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_gt?: InputMaybe<Scalars['Bytes']['input']>;
  id_gte?: InputMaybe<Scalars['Bytes']['input']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id_lt?: InputMaybe<Scalars['Bytes']['input']>;
  id_lte?: InputMaybe<Scalars['Bytes']['input']>;
  id_not?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newImplementation?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newImplementation_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newStatus?: InputMaybe<Scalars['Int']['input']>;
  newStatus_gt?: InputMaybe<Scalars['Int']['input']>;
  newStatus_gte?: InputMaybe<Scalars['Int']['input']>;
  newStatus_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  newStatus_lt?: InputMaybe<Scalars['Int']['input']>;
  newStatus_lte?: InputMaybe<Scalars['Int']['input']>;
  newStatus_not?: InputMaybe<Scalars['Int']['input']>;
  newStatus_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  or?: InputMaybe<Array<InputMaybe<UpgradeableProposalStatusChanged_Filter>>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum UpgradeableProposalStatusChanged_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  NewImplementation = 'newImplementation',
  NewStatus = 'newStatus',
  TransactionHash = 'transactionHash'
}

export type UpgradeableProposal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<UpgradeableProposal_Filter>>>;
  approvedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_?: InputMaybe<UpgradeableProposalApproved_Filter>;
  approvedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent?: InputMaybe<Scalars['String']['input']>;
  createdEvent_?: InputMaybe<UpgradeableProposalCreated_Filter>;
  createdEvent_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_gte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_lt?: InputMaybe<Scalars['String']['input']>;
  createdEvent_lte?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  createdEvent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdEvent_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  keyKeeperApproved?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  keyKeeperApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  keyKeeperApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  newImplementation?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newImplementation_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newImplementation_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<UpgradeableProposal_Filter>>>;
  ownerApproved?: InputMaybe<Scalars['Boolean']['input']>;
  ownerApproved_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  ownerApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  ownerApproved_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  statusChangedEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_?: InputMaybe<UpgradeableProposalStatusChanged_Filter>;
  statusChangedEvents_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  statusChangedEvents_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum UpgradeableProposal_OrderBy {
  ApprovedEvents = 'approvedEvents',
  CreatedEvent = 'createdEvent',
  CreatedEventBlockNumber = 'createdEvent__blockNumber',
  CreatedEventBlockTimestamp = 'createdEvent__blockTimestamp',
  CreatedEventId = 'createdEvent__id',
  CreatedEventNewImplementation = 'createdEvent__newImplementation',
  CreatedEventTransactionHash = 'createdEvent__transactionHash',
  Id = 'id',
  KeyKeeperApproved = 'keyKeeperApproved',
  NewImplementation = 'newImplementation',
  OwnerApproved = 'ownerApproved',
  Status = 'status',
  StatusChangedEvents = 'statusChangedEvents'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type OwnershipsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Ownership_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Ownership_Filter>;
}>;


export type OwnershipsQuery = { __typename?: 'Query', ownerships: Array<{ __typename?: 'Ownership', id: string, owner: any, index: any, amount: any, lockupDeadline: any, status: number }> };

export type CancelLockupProposalsQueryVariables = Exact<{
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CancelLockupProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CancelLockupProposal_Filter>;
}>;


export type CancelLockupProposalsQuery = { __typename?: 'Query', cancelLockupProposals: Array<{ __typename?: 'CancelLockupProposal', id: string, owner: any, index: any, administratorApproved: boolean, keyKeeperApproved: boolean, tokenOwnerApproved: boolean, status: number, ownership: { __typename?: 'Ownership', id: string, owner: any, index: any, amount: any, lockupDeadline: any, status: number } }> };

export type ExtendLockupPeriodProposalsQueryVariables = Exact<{
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExtendLockupPeriodProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExtendLockupPeriodProposal_Filter>;
}>;


export type ExtendLockupPeriodProposalsQuery = { __typename?: 'Query', extendLockupPeriodProposals: Array<{ __typename?: 'ExtendLockupPeriodProposal', id: string, owner: any, index: any, extensionPeriod: any, administratorApproved: boolean, keyKeeperApproved: boolean, status: number, ownership: { __typename?: 'Ownership', id: string, owner: any, index: any, amount: any, lockupDeadline: any, status: number } }> };

export type GrantKeyKeeperProposalsQueryVariables = Exact<{
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GrantKeyKeeperProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GrantKeyKeeperProposal_Filter>;
}>;


export type GrantKeyKeeperProposalsQuery = { __typename?: 'Query', grantKeyKeeperProposals: Array<{ __typename?: 'GrantKeyKeeperProposal', id: string, newKeyKeeper: any, administratorApproved: boolean, keyKeeperApproved: boolean, status: number }> };

export type RevokeKeyKeeperProposalsQueryVariables = Exact<{
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RevokeKeyKeeperProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RevokeKeyKeeperProposal_Filter>;
}>;


export type RevokeKeyKeeperProposalsQuery = { __typename?: 'Query', revokeKeyKeeperProposals: Array<{ __typename?: 'RevokeKeyKeeperProposal', id: string, keyKeeper: any, administratorApproved: boolean, keyKeeperApproved: boolean, status: number }> };

export type TransferOwnershipProposalsQueryVariables = Exact<{
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransferOwnershipProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransferOwnershipProposal_Filter>;
}>;


export type TransferOwnershipProposalsQuery = { __typename?: 'Query', transferOwnershipProposals: Array<{ __typename?: 'TransferOwnershipProposal', id: string, newOwner: any, administratorApproved: boolean, keyKeeperApproved: boolean, status: number }> };

export type TransferTokenOwnershipProposalsQueryVariables = Exact<{
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransferTokenOwnershipProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransferTokenOwnershipProposal_Filter>;
}>;


export type TransferTokenOwnershipProposalsQuery = { __typename?: 'Query', transferTokenOwnershipProposals: Array<{ __typename?: 'TransferTokenOwnershipProposal', id: string, owner: any, index: any, newOwner: any, status: number, ownership: { __typename?: 'Ownership', id: string, owner: any, index: any, amount: any, lockupDeadline: any, status: number } }> };

export type UpgradeableProposalsQueryVariables = Exact<{
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UpgradeableProposal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UpgradeableProposal_Filter>;
}>;


export type UpgradeableProposalsQuery = { __typename?: 'Query', upgradeableProposals: Array<{ __typename?: 'UpgradeableProposal', id: string, newImplementation: any, ownerApproved: boolean, keyKeeperApproved: boolean, status: number }> };

export type RolesQueryVariables = Exact<{
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Role_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Role_Filter>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, account: any }> };


export const OwnershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ownerships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Ownership_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Ownership_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownerships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lockupDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<OwnershipsQuery, OwnershipsQueryVariables>;
export const CancelLockupProposalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"cancelLockupProposals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"block"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Block_height"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelLockupProposal_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelLockupProposal_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelLockupProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"Variable","name":{"kind":"Name","value":"block"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"administratorApproved"}},{"kind":"Field","name":{"kind":"Name","value":"keyKeeperApproved"}},{"kind":"Field","name":{"kind":"Name","value":"tokenOwnerApproved"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lockupDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<CancelLockupProposalsQuery, CancelLockupProposalsQueryVariables>;
export const ExtendLockupPeriodProposalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"extendLockupPeriodProposals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"block"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Block_height"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendLockupPeriodProposal_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExtendLockupPeriodProposal_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extendLockupPeriodProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"Variable","name":{"kind":"Name","value":"block"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"extensionPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"administratorApproved"}},{"kind":"Field","name":{"kind":"Name","value":"keyKeeperApproved"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lockupDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ExtendLockupPeriodProposalsQuery, ExtendLockupPeriodProposalsQueryVariables>;
export const GrantKeyKeeperProposalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"grantKeyKeeperProposals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"block"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Block_height"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GrantKeyKeeperProposal_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GrantKeyKeeperProposal_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantKeyKeeperProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"Variable","name":{"kind":"Name","value":"block"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"newKeyKeeper"}},{"kind":"Field","name":{"kind":"Name","value":"administratorApproved"}},{"kind":"Field","name":{"kind":"Name","value":"keyKeeperApproved"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GrantKeyKeeperProposalsQuery, GrantKeyKeeperProposalsQueryVariables>;
export const RevokeKeyKeeperProposalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"revokeKeyKeeperProposals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"block"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Block_height"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RevokeKeyKeeperProposal_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RevokeKeyKeeperProposal_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeKeyKeeperProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"Variable","name":{"kind":"Name","value":"block"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyKeeper"}},{"kind":"Field","name":{"kind":"Name","value":"administratorApproved"}},{"kind":"Field","name":{"kind":"Name","value":"keyKeeperApproved"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<RevokeKeyKeeperProposalsQuery, RevokeKeyKeeperProposalsQueryVariables>;
export const TransferOwnershipProposalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"transferOwnershipProposals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"block"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Block_height"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransferOwnershipProposal_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransferOwnershipProposal_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferOwnershipProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"Variable","name":{"kind":"Name","value":"block"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"newOwner"}},{"kind":"Field","name":{"kind":"Name","value":"administratorApproved"}},{"kind":"Field","name":{"kind":"Name","value":"keyKeeperApproved"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<TransferOwnershipProposalsQuery, TransferOwnershipProposalsQueryVariables>;
export const TransferTokenOwnershipProposalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"transferTokenOwnershipProposals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"block"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Block_height"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransferTokenOwnershipProposal_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransferTokenOwnershipProposal_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferTokenOwnershipProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"Variable","name":{"kind":"Name","value":"block"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"newOwner"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lockupDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<TransferTokenOwnershipProposalsQuery, TransferTokenOwnershipProposalsQueryVariables>;
export const UpgradeableProposalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"upgradeableProposals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"block"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Block_height"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradeableProposal_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradeableProposal_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradeableProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"Variable","name":{"kind":"Name","value":"block"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"newImplementation"}},{"kind":"Field","name":{"kind":"Name","value":"ownerApproved"}},{"kind":"Field","name":{"kind":"Name","value":"keyKeeperApproved"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpgradeableProposalsQuery, UpgradeableProposalsQueryVariables>;
export const RolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"block"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Block_height"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Role_orderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderDirection"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Role_filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"Variable","name":{"kind":"Name","value":"block"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"}}]}}]}}]} as unknown as DocumentNode<RolesQuery, RolesQueryVariables>;